/**
 * Scripts pour l'usage du menu mobile.
 */

import { A, O, pipe } from "@mobily/ts-belt";
import A11yDialog from "a11y-dialog";

import { ATTRIBUT_MENU_MOBILE_ACTIVE, SELECTEUR_BOUTON_MENU_MOBILE, SELECTEUR_MENU_MOBILE } from "./constantes/dom.ts";
import { recupereEleOuLeve } from "./lib/utils.ts";

// Éléments d'intérêt
const E = {
  BOUTON_MENU_MOBILE: recupereEleOuLeve<HTMLButtonElement>(SELECTEUR_BOUTON_MENU_MOBILE),
  CORPS_HTML: recupereEleOuLeve<HTMLBodyElement>("body"),
  MENU_MOBILE: recupereEleOuLeve<HTMLDivElement>(SELECTEUR_MENU_MOBILE),
};

const initialiseBoutonMenuMobile = (): void => {
  const menuMobile = new A11yDialog(E.MENU_MOBILE);

  new ResizeObserver(entrees =>
    // Cache le Menu mobile pour les grandes tailles d'écrans
    pipe(
      A.head(entrees),
      O.filter((entree: ResizeObserverEntry) => entree.borderBoxSize[0]!.inlineSize > 1000),
      O.tap(_ => menuMobile.hide()),
    )
  ).observe(E.CORPS_HTML);

  E.BOUTON_MENU_MOBILE.addEventListener("click", (): void => {
    // Renvoie à la Page d'accueil pour les grandes tailles d'écrans
    if (window.innerWidth > 1000) {
      window.location.href = "/";
      return;
    }
    // Cache le Menu mobile s'il est actif
    if (E.BOUTON_MENU_MOBILE.hasAttribute(ATTRIBUT_MENU_MOBILE_ACTIVE)) {
      menuMobile.hide();
      return;
    }

    // Active le Menu mobile
    menuMobile.show();
  });

  // Active/Désactive l'Attribut indiquant l'ouverture du Menu mobile
  menuMobile.on("show", (): void => {
    E.BOUTON_MENU_MOBILE.setAttribute(ATTRIBUT_MENU_MOBILE_ACTIVE, "");
  });
  menuMobile.on("hide", (): void => {
    E.BOUTON_MENU_MOBILE.removeAttribute(ATTRIBUT_MENU_MOBILE_ACTIVE);
  });
};

document.addEventListener("DOMContentLoaded", (): void => {
  initialiseBoutonMenuMobile();
});
